export default __webpack_public_path__ + "static/media/Frame773.b284ff86.png";